import { render, staticRenderFns } from "./ServiceSelector.vue?vue&type=template&id=12f8a2a8"
import script from "./ServiceSelector.vue?vue&type=script&lang=ts"
export * from "./ServiceSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports